var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-profile"},[_c('a',{staticClass:"username username-custom",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.username))])])
}
var staticRenderFns = []

export { render, staticRenderFns }